// src/firebase.js

// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
// Firestore and Storage removed — only used by deprecated _NotesList.js and test TestUpload.js.
// Removing saves ~150KB bundle + faster Firebase init (fewer modules to initialize).

// CRITICAL: No default values allowed - fail fast if environment variables are missing
// This ensures proper configuration in all environments
const getRequiredEnvVar = (name) => {
  const value = process.env[name];
  if (!value) {
    throw new Error(
      `Missing required environment variable: ${name}. ` +
      `Please ensure all Firebase configuration is set in your environment.`
    );
  }
  return value;
};

const firebaseConfig = {
  // Production should use auth.blackmount.ai for authDomain
  // This provides professional branding instead of firebaseapp.com
  apiKey: getRequiredEnvVar('REACT_APP_FIREBASE_API_KEY'),
  authDomain: getRequiredEnvVar('REACT_APP_FIREBASE_AUTH_DOMAIN'),
  projectId: getRequiredEnvVar('REACT_APP_FIREBASE_PROJECT_ID'),
  storageBucket: getRequiredEnvVar('REACT_APP_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: getRequiredEnvVar('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
  appId: getRequiredEnvVar('REACT_APP_FIREBASE_APP_ID'),
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services — auth only (Firestore/Storage not needed by the webapp)
export const auth = getAuth(app);